import { savedOrderListFilterStyles as styles } from "@solveindustrial/Overrides/Widgets/SavedOrderList/SavedOrderListFilter";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    gap: 0,
    offsetCss: css`
        ${styles.container?.offsetCss}
        width: 100%;
        gap: 16px;
    `,
};

styles.headingGridItem = {
    ...styles.headingGridItem,
    css: css`
        ${styles.headingGridItem?.css}
        padding: 16px 0;
    `,
};

styles.fromGridItem = {
    ...styles.fromGridItem,
    css: css`
        & > div {
            width: 100%;
        }
    `,
};

styles.toGridItem = {
    ...styles.toGridItem,
    css: css`
        & > div {
            width: 100%;
        }
    `,
};

styles.orderTotalAmountGridItem = {
    ...styles.orderTotalAmountGridItem,
    css: css`
        justify-content: flex-end;
        align-items: flex-end;
    `,
};

styles.orderTotalAmountTextField = {
    cssOverrides: {
        formInputWrapper: css`
            margin: 0;
        `,
    },
};

styles.heading = {
    ...styles.heading,
    variant: "h4",
};

styles.clearFiltersButton = {
    ...styles.clearFiltersButton,
    css: css`
        ${styles.clearFiltersButton?.css}
        margin-right: 0;
    `,
};

styles.orderTotalGridItem = {
    ...styles.orderTotalGridItem,
    css: css`
        ${styles.orderTotalGridItem?.css}
        padding: 0;
        ${mediaQueriesBP.minLG} {
            flex-basis: 32%;
            max-width: 32%;
        }
    `,
};

styles.datesGridItem = {
    ...styles.datesGridItem,
    css: css`
        ${styles.datesGridItem?.css}
        padding: 0;
        ${mediaQueriesBP.minLG} {
            flex-basis: 32%;
            max-width: 32%;
        }
    `,
};